module.exports = __webpack_public_path__ + "images/backgrounds/mountain/large.cdd5242208953ec94372.jpg";